import React from "react";
import { Card, CardBody } from "reactstrap";

const CityLabels = ({ cities = [] }) => (
  <Card>
    <CardBody>
      <p className="text-truncate font-size-14 mb-3">Listed by city</p>
      {cities.length === 0 ? (
        <p className="text-muted font-size-13 mb-0">No listed properties yet</p>
      ) : (
        <div className="d-flex flex-wrap gap-2">
          {cities.map((city) => (
            <span
              key={city.name}
              className="badge border bg-light text-body font-size-13 fw-medium px-3 py-2"
            >
              {city.name}
              <span className="text-muted ms-2">
                {Number(city.count || 0).toLocaleString("en-US")}
              </span>
            </span>
          ))}
        </div>
      )}
    </CardBody>
  </Card>
);

export default CityLabels;
